import Api from 'api'

const config = {
  baseURL: '/api/app/v1/notifications',
}
const api = new Api(config)

api.fetch = ({ ...rest }) => api.get('', { ...rest })

export default api
